<script>
export default {
  name: "TextField",
  props: {
    value:        { type: Object, required: true },
  },
  computed: {
    placeholder() {
      return this.value.placeholder ? this.value.placeholder : "" 
    },
    message()     {
      return this.value.message ? this.value.message : "" 
    },
    tip()         {
      return this.value.tip ? this.value.tip : "" 
    },
    state()       {
      return this.value.state ? this.value.state : null 
    },
    readOnly()    {
      return this.value.readOnly ? this.value.readOnly : false 
    },
    label()       {
      return this.value.label ? this.value.label : "" 
    },
    id()          {
      return this.value.id ? this.value.id : Date.now().toString(36) 
    },
  },
  watch: {
    value() {
      this.$emit("input", this.value)
    },
  },
  methods: {
    onChange() {
      this.$emit("change", {
        id: this.id,
        value: this.value.value,
      })
    },
  },
}
</script>

<template>
  <div class="textField">
    <label
      v-if="label && label !== ''"
      :for="id"
      class="font-weight-bold"
    >
      {{ label }}
    </label>
    <b-form-input
      :id="id"
      v-model="value.value"
      :readonly="readOnly"
      :placeholder="placeholder"
      :state="state"
      :aria-describedby="id + '-live-help ' + id + '-live-feedback'"
      trim
      @change="onChange"
    />
    <b-form-invalid-feedback :id="id + '-live-feedback'">{{message}}</b-form-invalid-feedback>
    <b-form-text v-if="tip" :id="id + '-live-help'">{{tip}}</b-form-text>
  </div>
</template>

<style scoped>
.textField {
  margin-bottom: 0.5rem;
}
</style>
